/**
 * Derives the canonical provider ID and profile type from an entity details
 * object. This is the single source of truth for the two-value derivation
 * that was previously repeated across 50+ widget files.
 *
 * `providerId` prefers the internal MedScout `provider_id`; falls back to the
 * external `id` (NPI / CMS Provider ID / System ID) when `provider_id` is
 * absent.
 *
 * `profileType` returns the entity's `type` field, defaulting to `'hcp'` when
 * absent — matching the dominant convention across all widget call sites.
 * Callers that need a different default (e.g. `'center'`, `'system'`) can
 * override after destructuring.
 */
const getEntityIdentifiers = (
  entityDetails: Record<string, any> | null | undefined
): { providerId: string | undefined; profileType: string } => {
  const providerId = entityDetails?.provider_id || entityDetails?.id;
  const profileType = entityDetails?.type || 'hcp';
  return { providerId, profileType };
};

export default getEntityIdentifiers;
